import React, {useEffect, useState} from 'react';
import { Button, TableContainer, TextField } from '@material-ui/core'
import { useParams} from "react-router-dom";
import EventAdminNav from "./EventAdminNav";
import {EventIntf} from "../ServerTypes";
import AttendeeTable from "./AttendeeTable"


export default function ManageAttendees() {

    const [searchString, setSearchString] = useState("")
    const [submittedSearchString, setSubmittedSearchString] = useState("")
    const {eventId} = useParams()

    const [event, setEvent] = useState(null)
    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/events/${eventId}`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(event => {
                setEvent(event)
            })
    }, [])

    const handleInputChange = (event) => {
        setSearchString(event.target.value)
    }

    const handleUserSearch = () => {
        setSubmittedSearchString(searchString)
    }



    // console.log(eventId)
    return (event?

        <div>
            <EventAdminNav event={event}/>
            {/*<EventAdminNav/>*/}
            <p>Total Attendees: {0}</p><a>More Info <span role="img" aria-label="arrow">➡️</span> </a>
            <TextField value={searchString} onChange={handleInputChange}/> 
            <Button onClick={handleUserSearch} id="search-attendees-button" variant="contained" color="primary">Search</Button>
            
            <TableContainer> 
                <AttendeeTable event={event} submittedSearchString={submittedSearchString}/>
            </TableContainer>

        </div> :
            <></>
    )
}
